import { render } from "./arrangeGrade.vue?vue&type=template&id=0f29dd34&scoped=true"
import script from "./arrangeGrade.vue?vue&type=script&lang=js"
export * from "./arrangeGrade.vue?vue&type=script&lang=js"

import "./arrangeGrade.vue?vue&type=style&index=0&id=0f29dd34&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f29dd34"]])

export default __exports__